import { useState } from "react"
import { router } from "@inertiajs/react"
import { Check } from "lucide-react"
import { cn } from "@/lib/utils"
import { GroupContextTrigger } from "@/components/GroupContextTrigger"
import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogDescription,
  ResponsiveDialogHeader,
  ResponsiveDialogTitle,
} from "@/components/ui/responsive-dialog"
import { Button } from "@/components/ui/button"

export function GroupSwitcher({ currentGroup, userGroups, className }) {
  const [open, setOpen] = useState(false)
  const [switching, setSwitching] = useState(false)

  if (!userGroups || userGroups.length <= 1) return null

  const handleSwitch = (groupId) => {
    if (groupId === currentGroup?.id) {
      setOpen(false)
      return
    }

    setSwitching(true)
    router.patch(
      "/app/member/group_switch",
      { group_id: groupId },
      {
        onFinish: () => {
          setSwitching(false)
          setOpen(false)
        },
      }
    )
  }

  return (
    <ResponsiveDialog open={open} onOpenChange={(next) => setOpen(next)}>
      <GroupContextTrigger
        groupName={currentGroup?.name}
        busy={switching}
        ariaLabel={`Change member group — currently viewing ${currentGroup?.name ?? "a group"}.`}
        className={className}
        onClick={() => setOpen(true)}
      />
      <ResponsiveDialogContent>
        <ResponsiveDialogHeader>
          <ResponsiveDialogTitle>Choose a group</ResponsiveDialogTitle>
          <ResponsiveDialogDescription>
            This reloads member content for whichever group you select.
          </ResponsiveDialogDescription>
        </ResponsiveDialogHeader>
        <div className="px-4 pb-4 space-y-1">
          {userGroups.map((group) => (
            <Button
              key={group.id}
              variant="ghost"
              className="w-full justify-start gap-3 h-11"
              onClick={() => handleSwitch(group.id)}
              disabled={switching}
            >
              <Check
                className={cn(
                  "h-4 w-4 shrink-0",
                  group.id === currentGroup?.id ? "opacity-100" : "opacity-0"
                )}
              />
              <span className="truncate flex-1 text-left">{group.name}</span>
              {group.role === "coach" && (
                <span className="ml-2 shrink-0 rounded bg-zinc-100 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-zinc-500">
                  Coach
                </span>
              )}
            </Button>
          ))}
        </div>
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  )
}
